module.exports = __webpack_public_path__ + "img/businesses.302fbe63.svg";